// extracted by mini-css-extract-plugin
export default {"emptyBlock":"emptyBlock_emptyBlock__Dy45Z","emptyBlockInner":"emptyBlock_emptyBlockInner__M4oqT"};